module.exports = __webpack_public_path__ + "img/aiwriter_generator1.1a8cf6c3.jpg";